export default __webpack_public_path__ + "static/tabs-independent-dont-b0951ed3484aba68152818e484bf5374d4f49e6a35a9298c062f7934174d5a02.png";